import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { Link, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import defaultimage from "../assets/default-image.png";
import Swal from 'sweetalert2';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { faEye ,faComment} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const ViewPostComments = () => {
    const navigate = useNavigate();
    const { LinkdinPostId } = useParams(); // Get the LinkedIn Post ID from the route parameter
    const searchParams = new URLSearchParams(window.location.search);
    const facebookPostIdFromUrl = searchParams.get('facebookPostId'); // Get FacebookPostId from query params
    const [commentsData, setCommentsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const UserID = localStorage.getItem("UserID");
    const AccessToken = localStorage.getItem('AccessToken');
    const [replyText, setReplyText] = useState({}); // Store reply text for each comment
    const [replies, setReplies] = useState({}); // Store replies for each comment
    const [accessToken, setAccessToken] = useState('');
    const [userId, setUserId] = useState('');
      const [accounttype, setAccountType] = useState('');
      const [disabledReplies, setDisabledReplies] = useState({}); // Track disabled replies
      const [replyEditText, setReplyEditText] = useState({}); // Text for editing replies
      const [editingReply, setEditingReply] = useState(null); // Track the reply being edited
      const [engagementStats, setEngagementStats] = useState(0);
      const [commentStats, setCommentStats] = useState(0);
      const [facebookComments, setFacebookComments] = useState([]);
      const [facebookEngagementStats, setFacebookEngagementStats] = useState(0);
      const [facebookCommentStats, setFacebookCommentStats] = useState(0);
      const [facebookPostId, setFacebookPostId] = useState(null);
      
      useEffect(() => {
        const storedAccessToken = localStorage.getItem('AccessToken');
        const storedUserId = localStorage.getItem('Tokenid');
        const storedAccountType = localStorage.getItem('AccountType');
        
        if (storedAccessToken && storedUserId && storedAccountType) {
           
          setAccessToken(storedAccessToken);
          setUserId(storedUserId);
          setAccountType(storedAccountType);
        } else {
          console.error('No accessToken or userId found in localStorage');
        }
      }, []);
    
    useEffect(() => {
        const fetchComments = async () => {
            setLoading(true);
            try {
                const params = {
                    LinkdinPostId,
                    AccessToken,
                    AccountType: accounttype,
                    UserID: UserID || localStorage.getItem('UserID'),
                };
                
                // Only add FacebookPostId if it exists in URL (optional)
                if (facebookPostIdFromUrl) {
                    params.FacebookPostId = facebookPostIdFromUrl;
                }
                
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getcommentsbasedonlinkedinpostid`, {
                    params,
                });

                if (response.data.comments) {
                    setCommentsData(response.data.comments);
                    setEngagementStats(response.data.engagementStats || 0);
                    setCommentStats(response.data.commentStats || 0);
                    
                    // Set Facebook data if available (optional - won't break if not present)
                    if (response.data.facebookComments) {
                        setFacebookComments(response.data.facebookComments || []);
                        setFacebookEngagementStats(response.data.facebookEngagementStats || 0);
                        setFacebookCommentStats(response.data.facebookCommentStats || 0);
                        setFacebookPostId(response.data.facebookPostId || null);
                    } else if (response.data.facebookPostId) {
                        // If FacebookPostId exists but no comments, still set it for display
                        setFacebookPostId(response.data.facebookPostId);
                    }
                } else {
                    setError('No comments found for this post');
                }
            } catch (err) {
                console.error('Failed to fetch comments:', err.message);
                setError('No Comments Found');
            } finally {
                setLoading(false);
            }
        };

        if (LinkdinPostId) {
            fetchComments();
        }
    }, [LinkdinPostId, AccessToken, accounttype, facebookPostIdFromUrl]);

    const handleReplyChange = (commentIndex, text) => {
        setReplyText((prev) => ({
            ...prev,
            [`${LinkdinPostId}-${commentIndex}`]: text,
        }));
    };

    const handleFacebookReplyChange = (commentIndex, text) => {
        setReplyText((prev) => ({
            ...prev,
            [`fb-${commentIndex}`]: text,
        }));
    };

    

    const handleReplySubmit = async (commentIndex) => {
        const replyKey = `${LinkdinPostId}-${commentIndex}`;
        const replyContent = replyText[replyKey];
        const parentUrn = commentsData[commentIndex]?.parentUrn;
    
        if (!replyContent || !parentUrn) {
            console.error('Missing reply content or parent URN');
            return;
        }
    
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/replyToComment`, {
                LinkdinPostId,
                AccessToken,
                UserID: userId,
                parentUrn,
                replyText: replyContent,
                accounttype,
            });
    
            if (response.data) {
                // Update the local state with the new reply
                const updatedComments = [...commentsData];
                updatedComments[commentIndex] = {
                    ...updatedComments[commentIndex],
                    replies: [
                        ...(updatedComments[commentIndex].replies || []),
                        { message: replyContent, actor: 'You', profilePictureUrl: defaultimage }, // Add the new reply
                    ],
                };
    
                setCommentsData(updatedComments); // Update the state with new data
               
    
                // Clear the reply text and disable the input for this comment
                setReplyText((prev) => ({
                    ...prev,
                    [replyKey]: '',
                }));
    
                setDisabledReplies((prev) => ({
                    ...prev,
                    [replyKey]: true,
                }));
                    Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Replied successfully',
                                showConfirmButton: false,
                                timer: 3000
                            });
                    
            }
            // Refresh comments after the reply
        await fetchComments();
        } catch (error) {
            console.error('Failed to submit reply:', error.response?.data || error.message);
        }
    };
    
    
    console.log(commentsData);


    const handleEditReplySubmit = async (commentIndex, replyIndex) => {
   
        const key = `${LinkdinPostId}-${commentIndex}-${replyIndex}`;
        const updatedText = replyEditText[key];
        const parentUrn = commentsData[commentIndex]?.parentUrn;
        const replyId = commentsData[commentIndex]?.replies[replyIndex]?.id;

        if (!updatedText || !parentUrn || !replyId) {
            console.error('Missing required fields for updating reply');
            return;
        }

        try {
       
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/editReply`, {
                LinkdinPostId,
                accessToken,
                userId,
                parentUrn,
                replyId,
                updatedText,
                accounttype,
             
            });

            if (response.data.success) {
                const updatedComments = [...commentsData];
                updatedComments[commentIndex].replies[replyIndex].message = updatedText;

                setCommentsData(updatedComments); // Update state
                setReplyEditText((prev) => ({
                    ...prev,
                    [key]: '',
                }));
            }
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Updated successfully',
                showConfirmButton: false,
                timer: 3000
            });
             // Refresh comments after deleting the reply
        await fetchComments();

        } catch (error) {
            console.error('Failed to update reply:', error.response?.data || error.message);
        }
    };

    
    const handleReplyDeleteSubmit = async (commentIndex, replyIndex) => {
        const key = `${LinkdinPostId}-${commentIndex}-${replyIndex}`;
        const parentUrn = commentsData[commentIndex]?.parentUrn;
        const replyId = commentsData[commentIndex]?.replies[replyIndex]?.id;


        try {
          
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/replyDelete`, {
                LinkdinPostId,
                accessToken,
                userId,
                parentUrn,
                replyId,
                accounttype,
             
            });
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Deleted successfully',
                showConfirmButton: false,
                timer: 3000
            });
             // Refresh comments after deleting the reply
        await fetchComments();

        } catch (error) {
            console.error('Failed to delete reply:', error.response?.data || error.message);
        }
    };

    const handleFacebookReplySubmit = async (commentIndex) => {
        const replyKey = `fb-${commentIndex}`;
        const replyContent = replyText[replyKey];
        const facebookCommentId = facebookComments[commentIndex]?.id;
    
        if (!replyContent || !facebookCommentId) {
            console.error('Missing reply content or Facebook comment ID');
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Please enter a reply',
                showConfirmButton: false,
                timer: 2000
            });
            return;
        }
    
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/replyToComment`, {
                LinkdinPostId,
                AccessToken,
                UserID: UserID || localStorage.getItem('UserID'),
                parentUrn: facebookCommentId,
                replyText: replyContent,
                accounttype,
                platform: 'facebook',
                FacebookPostId: facebookPostId,
                FacebookCommentId: facebookCommentId,
            });
    
            if (response.data) {
                // Clear the reply text and disable the input for this comment
                setReplyText((prev) => ({
                    ...prev,
                    [replyKey]: '',
                }));
                
                setDisabledReplies((prev) => ({
                    ...prev,
                    [replyKey]: true,
                }));
                
                // Show success message first
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Replied successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                
                // Wait a moment for Facebook to process the reply, then refresh comments
                setTimeout(async () => {
                    await fetchComments();
                }, 1500);
            }
        } catch (error) {
            console.error('Failed to post Facebook reply:', error.response?.data || error.message);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Failed to post reply',
                text: error.response?.data?.error || error.message || 'Please try again',
                showConfirmButton: false,
                timer: 3000
            });
        }
    };

    const fetchComments = async () => {
        setLoading(true);
        try {
            const params = {
                LinkdinPostId,
                AccessToken,
                AccountType: accounttype,
                UserID: UserID || localStorage.getItem('UserID'),
            };
            
            // Add FacebookPostId if available from URL
            if (facebookPostIdFromUrl) {
                params.FacebookPostId = facebookPostIdFromUrl;
            }
            
            console.log('📤 Fetching comments with params:', params);
            
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getcommentsbasedonlinkedinpostid`, {
                params,
            });
    
            if (response.data.comments) {
                setCommentsData(response.data.comments);
                setEngagementStats(response.data.engagementStats || 0);
                setCommentStats(response.data.commentStats || 0);
                
                // Set Facebook data if available
                console.log('📥 Response data:', {
                    hasFacebookComments: !!response.data.facebookComments,
                    facebookCommentsCount: response.data.facebookComments?.length || 0,
                    facebookPostId: response.data.facebookPostId,
                    facebookEngagementStats: response.data.facebookEngagementStats,
                    facebookCommentStats: response.data.facebookCommentStats,
                });
                
                // Set Facebook data if available (optional - won't break if not present)
                if (response.data.facebookComments) {
                    setFacebookComments(response.data.facebookComments || []);
                    setFacebookEngagementStats(response.data.facebookEngagementStats || 0);
                    setFacebookCommentStats(response.data.facebookCommentStats || 0);
                    setFacebookPostId(response.data.facebookPostId || null);
                } else if (response.data.facebookPostId) {
                    // If FacebookPostId exists but no comments, still set it for display
                    setFacebookPostId(response.data.facebookPostId);
                }
            } else {
                setError('No comments found for this post');
            }
        } catch (err) {
            console.error('Failed to fetch comments:', err.message);
            setError('No Comments Found');
        } finally {
            setLoading(false);
        }
    };

return (
    <SideNavbar>
        <div className="container">
            <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
            <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}> 
  <Link to="/viewallpostedposts" style={{ textDecoration: 'none' }}>
    <h5
      className="welcome-text"
      style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left', margin: 0 }}
    >
      <i
        className="fa fa-arrow-left"
        style={{ marginRight: '30px' }}
        aria-hidden="true"
      ></i>
      LinkedIn Comments
    </h5>
  </Link>

  <span style={{ fontSize: '16px', color: '#555' }}>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-likes">Likes</Tooltip>}
    >
      <i
        className="fa fa-thumbs-up"
        aria-hidden="true"
        style={{ marginRight: '5px', color: '#2e3192', cursor: 'pointer' }}
      ></i>
    </OverlayTrigger>
    {engagementStats}

    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-comments">Comments</Tooltip>}
    >
      <i
        className="fa fa-comment"
        aria-hidden="true"
        style={{ marginLeft: '15px', marginRight: '5px', color: '#2e3192', cursor: 'pointer' }}
      ></i>
    </OverlayTrigger>
    {commentStats}
    
    {/* Facebook Stats - Show if FacebookPostId exists */}
    {facebookPostId && accounttype === 'Page' && (
      <>
        <span style={{ marginLeft: '20px', fontSize: '14px', color: '#6c757d' }}>
          <i className="fa fa-facebook" aria-hidden="true" style={{ marginRight: '5px', color: '#1877f2' }}></i>
          FB: {facebookEngagementStats} likes, {facebookCommentStats} comments
        </span>
      </>
    )}
  </span>
</div>

</div>

                <hr />
                {loading ? (
                    <div className="spinner"></div>
                ) : error ? (
                    <p>{error}</p>
                ) : (
                    <div>
                        {/* {/ <h6 className="mb-1" style={{ fontWeight: 500, color: 'black' }}>Comments:</h6> /} */}
                        {commentsData.length === 0 ? (
                            <p>No comments available</p>
                        ) : (
                            <ul style={{ listStyleType: 'none', padding: 0 }}>
                            {commentsData.map((comment, index) => (
    <li key={index} className="mb-3">
        {/* {/ Comment Section /} */}
        <div className="d-flex align-items-center mb-2">
            <img
                className="circle-image me-3"
                // src={comment.profilePictureUrl || 'default-image-url.jpg'}
                src={comment.profilePictureUrl !== 'default-profile-pic-url' ? comment.profilePictureUrl : defaultimage}
                alt="Profile"
                style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                }}
            />
            <div>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                    {comment.actor}
                </span>
                <br />
                <span style={{ color: 'gray', fontSize: '14px' }}>
                    {comment.headline || 'No headline available'}
                </span>
            </div>
        </div>
        <p style={{ color: 'black', marginLeft: '50px' }}>
            {comment.message || 'No comment text'}
        </p>

        {/* {/ Replies Section /} */}
        <div style={{ color: 'black', marginLeft: '50px' }}>
            {Array.isArray(comment.replies) && comment.replies.length > 0 ? (
                <ul>
                {comment.replies.map((reply, replyIndex) => (
    <li key={replyIndex} style={{ listStyleType: 'none' }}>
        <div className="d-flex align-items-center mb-2">
            <img
                className="circle-image me-3"
                src={reply.profilePictureUrl !== 'default-profile-pic-url' ? reply.profilePictureUrl : defaultimage}
                alt="Profile"
                style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                }}
            />
            <div>
                <span style={{ fontWeight: 'bold', color: 'black' }}>{reply.actor}</span>
                <br />
                <span style={{ color: 'gray', fontSize: '14px' }}>{reply.headline || ''}</span>
            </div>
        </div>

        {/* {/ Show Reply or Edit Input /} */}
        {editingReply === `${index}-${replyIndex}` ? (
    <div style={{ marginLeft: '50px' }}>
        <input
            type="text"
            className="form-control"
            value={replyEditText[`${LinkdinPostId}-${index}-${replyIndex}`] || reply.message}
            onChange={(e) =>
                setReplyEditText((prev) => ({
                    ...prev,
                    [`${LinkdinPostId}-${index}-${replyIndex}`]: e.target.value,
                }))
            }
        />
        <button
            className="btn btn-success mt-2"
            onClick={() => handleEditReplySubmit(index, replyIndex)}
        >
            Save
        </button>
        <button
            className="btn btn-secondary mt-2 ms-2"
            onClick={() => {
                setEditingReply(null); // Exit edit mode
                setReplyEditText((prev) => ({
                    ...prev,
                    [`${LinkdinPostId}-${index}-${replyIndex}`]: '', // Clear edited text
                }));
            }}
        >
            Cancel
        </button>
    </div>
) : (
    <>
        <p style={{ color: 'black', marginLeft: '50px' }}>{reply.message || 'No reply text'}</p>
        <div style={{ marginLeft: '50px' }}>
            <button
                className="btn btn-link p-0 me-3"
                onClick={() => {
                    setEditingReply(`${index}-${replyIndex}`); // Enter edit mode
                    setReplyEditText((prev) => ({
                        ...prev,
                        [`${LinkdinPostId}-${index}-${replyIndex}`]: reply.message, // Pre-fill with current reply text
                    }));
                }}
            >
                Edit
            </button>
           
            <button className="btn btn-link p-0 text-danger" onClick={() =>
             handleReplyDeleteSubmit(index,replyIndex)}>Delete</button>
        </div>
    </>
)}

    </li>
))}

                </ul>
            ) : (
                <p style={{ marginLeft: '50px', color: 'gray' }}>No replies available</p>
            )}
        </div>

        {/* {/ Reply Input Section /} */}
        {!disabledReplies[`${LinkdinPostId}-${index}`] &&
            !(replies[`${LinkdinPostId}-${index}`]?.length > 0 || (Array.isArray(comment.replies) && comment.replies.length > 0)) && (
                <div className="mt-2" style={{ marginLeft: '50px' }}>
                    <input
                        type="text"
                        placeholder="Reply..."
                        value={replyText[`${LinkdinPostId}-${index}`] || ''}
                        onChange={(e) => handleReplyChange(index, e.target.value)}
                        className="form-control"
                    />
                    <button
                        className="btn btn-primary mt-2"
                        onClick={() => handleReplySubmit(index)}
                    >
                        Reply
                    </button>
                </div>
            )}
    </li>
    
))}



                            </ul>
                        )}
                        
                        {/* Facebook Comments Section */}
                        {facebookPostId && accounttype === 'Page' && (
                          <>
                            <hr style={{ marginTop: '30px', marginBottom: '20px' }} />
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                              <h5
                                className="welcome-text"
                                style={{ fontSize: '18px', color: '#2e3192', margin: 0 }}
                              >
                                Facebook Comments
                              </h5>
                            </div>
                            
                            {facebookComments.length === 0 ? (
                              <p>No Facebook comments available</p>
                            ) : (
                              <ul style={{ listStyleType: 'none', padding: 0 }}>
                                {facebookComments.map((comment, index) => (
                                  <li key={`fb-${index}`} className="mb-3">
                                    {/* Comment Section */}
                                    <div className="d-flex align-items-center mb-2">
                                      <img
                                        className="circle-image me-3"
                                        src={comment.profilePictureUrl !== 'default-profile-pic-url' ? comment.profilePictureUrl : defaultimage}
                                        alt="Profile"
                                        style={{
                                          width: '40px',
                                          height: '40px',
                                          borderRadius: '50%',
                                          objectFit: 'cover',
                                        }}
                                      />
                                      <div>
                                        <span style={{ fontWeight: 'bold', color: 'black' }}>
                                          {comment.actor}
                                        </span>
                                        <br />
                                        {comment.headline && (
                                          <span style={{ color: 'gray', fontSize: '14px' }}>
                                            {comment.headline}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <p style={{ color: 'black', marginLeft: '50px' }}>
                                      {comment.message || 'No comment text'}
                                    </p>

                                    {/* Replies Section */}
                                    <div style={{ color: 'black', marginLeft: '50px' }}>
                                      {Array.isArray(comment.replies) && comment.replies.length > 0 ? (
                                        <ul>
                                          {comment.replies.map((reply, replyIndex) => (
                                            <li key={`fb-reply-${replyIndex}`} style={{ listStyleType: 'none' }}>
                                              <div className="d-flex align-items-center mb-2">
                                                <img
                                                  className="circle-image me-3"
                                                  src={reply.profilePictureUrl !== 'default-profile-pic-url' ? reply.profilePictureUrl : defaultimage}
                                                  alt="Profile"
                                                  style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                  }}
                                                />
                                                <div>
                                                  <span style={{ fontWeight: 'bold', color: 'black' }}>{reply.actor}</span>
                                                  {reply.headline && (
                                                    <>
                                                      <br />
                                                      <span style={{ color: 'gray', fontSize: '14px' }}>{reply.headline}</span>
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                              <p style={{ color: 'black', marginLeft: '50px' }}>{reply.message || 'No reply text'}</p>
                                            </li>
                                          ))}
                                        </ul>
                                      ) : (
                                        <p style={{ marginLeft: '50px', color: 'gray' }}>No replies available</p>
                                      )}
                                    </div>

                                    {/* Reply Input Section for Facebook Comments */}
                                    {!disabledReplies[`fb-${index}`] && (
                                      <div className="mt-2" style={{ marginLeft: '50px' }}>
                                        <input
                                          type="text"
                                          placeholder="Reply to this comment..."
                                          value={replyText[`fb-${index}`] || ''}
                                          onChange={(e) => handleFacebookReplyChange(index, e.target.value)}
                                          className="form-control"
                                          style={{ maxWidth: '400px' }}
                                        />
                                        <button
                                          className="btn btn-primary mt-2"
                                          onClick={() => handleFacebookReplySubmit(index)}
                                          disabled={!replyText[`fb-${index}`] || replyText[`fb-${index}`].trim() === ''}
                                        >
                                          Reply
                                        </button>
                                      </div>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </>
                        )}
                    </div>
                )}
            </div>
        </div>
    </SideNavbar>
);

};

export default ViewPostComments;